module.exports = __webpack_public_path__ + "static/media/general-setting.9cf14f17.svg";